import React from "react";
import { Box, Typography, Button, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";

export default function ErrorPage({ error }) {
  const navigate = useNavigate();

  const handleBack = () => navigate(-1);

  return (
    <Box
      sx={{
        minHeight: "80vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "background.default",
        p: 2,
      }}
    >
      <Paper
        elevation={6}
        sx={{
          p: 4,
          maxWidth: 500,
          textAlign: "center",
          borderRadius: 4,
          animation: "fadeIn 0.6s ease-in-out",
        }}
      >
        <ReportProblemIcon
          color="warning"
          sx={{ fontSize: 60, mb: 2, animation: "pulse 2s infinite" }}
        />
        <Typography variant="h4" fontWeight="bold" gutterBottom color="primary">
          Oops!
        </Typography>

        <Typography variant="body1" color="text.secondary" mb={2}>
          Sorry, an unexpected error has occurred.
        </Typography>

        <Typography
          variant="subtitle1"
          sx={{
            fontStyle: "italic",
            color: "error.main",
            wordBreak: "break-word",
            mb: 3,
          }}
        >
          {error?.statusText || error?.message || "Something went wrong."}
        </Typography>

        <Button variant="contained" color="primary" onClick={handleBack}>
          Go Back
        </Button>
      </Paper>

      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(10px); }
            to { opacity: 1; transform: translateY(0); }
          }
          @keyframes pulse {
            0%, 100% { transform: scale(1); opacity: 1; }
            50% { transform: scale(1.1); opacity: 0.8; }
          }
        `}
      </style>
    </Box>
  );
}
